/*
 * Copyright (c) 2021 TechnoL0g.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 *
 */

import Chain from '@/services/chain';
import Explorer from '@/services/explorer';

export default {
    namespaced: true,

    state: {
        history: [],
        lpsA: [],
        lpsB: [],
        search: [],
        current: {},
    },

    getters: {
        history: state => state.history,
        lpsA: state => state.lpsA,
        lpsB: state => state.lpsB,
        search: state => state.search,
        current: state => state.current,
    },

    mutations: {
        SET_RESET(state) {
            state.history = {};
        },
        SET_HISTORY(state, payload) {
            state.history = payload;
        },
        SET_LPS_A(state, payload) {
            state.lpsA = payload.a;
        },
        SET_LP_SEARCH(state, payload) {
            state.search = payload;
        },
        SET_LP_CURRENT(state, payload) {
            state.current = payload;
        },
    },

    actions: {
        reset({commit}) {
            commit('SET_RESET')
        },
        async getHistory({commit}, values) {
            let data = await Chain.LpHistory(values);
            if (!data) {
                data = await Explorer.LpHistory(values);
            }

            if (data) {
                let LP = [];

                for (let i = 0; i < data.length; i++) {

                    let account = null;
                    try {
                        account = (await this.dispatch('app/getObjects', [data[i].op.op[1].account]))[0].name
                    } catch (e) {

                    }
                    LP.push({
                        id: data[i].id,
                        sequence: data[i].sequence,
                        time: data[i].time,
                        op_type: data[i].op_type,
                        account: account,
                        op: {
                            block_num: data[i].op.block_num,
                            trx_in_block: data[i].op.trx_in_block
                        },
                        result: data[i].op.result[1],
                    })
                }
                commit('SET_HISTORY', LP);
            }
            return data;
        },
        async LpExchange({commit}, values) {
            const data = await Chain.LpExchange(values);
            return data;
        },
        async LpStake({commit}, values) {
            const data = await Chain.LpStake(values);
            return data;
        },
        async LpUnStake({commit}, values) {
            const data = await Chain.LpUnStake(values);
            return data;
        },
        async LpCreate({commit}, values) {
            const data = await Chain.LpCreate(values);
            return data;
        },
        async LpsA({commit}, asset) {
            const data = await Explorer.LpsA(asset);
            if (data) {
                commit('SET_LPS_A', data);
            }
            return data;
        },
        async LpsB({commit}, asset) {
            const data = await Explorer.LpsB(asset);
            return data;
        },
        async LpSearch({commit}, asset) {
            const data = await Explorer.LpSearch(asset);
            if (data) {
                commit('SET_LP_SEARCH', data);
            }
            return data;
        },

        async LpSingle({commit}, shareAsset) {
            const data = await Explorer.LpSingle(shareAsset);
            if (data) {
                commit('SET_LP_CURRENT', data);
            }
            return data;
        },

        async LpGetAll({commit}, ids = []) {
            return (await this.dispatch('app/getObjects', ids))
        },

    }
}
